export const HOME_COLLAGE = {
  schedule: {
    title: "Production schedule",
    lines: ["Extrusion", "Winding", "Assembly"],
    times: ["08:00", "10:00", "12:00", "14:00"],
  },
  orders: {
    title: "Manufacturing orders",
    rows: [
      { order: "MO-881", label: "Planned qty", value: "1 200 m", progress: 82 },
      { order: "MO-882", label: "Reported", value: "560 m", progress: 47 },
      { order: "MO-883", label: "Operations done", value: "3 / 6", progress: 24 },
    ],
  },
  centres: {
    title: "Work centres",
    rows: [
      { label: "Extrusion 1", value: 84 },
      { label: "Winding 2", value: 67 },
      { label: "Assembly", value: 42 },
    ],
  },
  utilization: {
    title: "Utilization",
    value: "84%",
    label: "This week",
  },
} as const;